import {fullURL} from '../utils';
import axios from 'axios';

const LIST_SAVE = 'LIST_SAVE';
const LIST_UPDATE = 'LIST_UPDATE';

const LIST_DELETE = 'LIST_DELETE';
const LIST_REMOVE = 'LIST_REMOVE';

const LIST_FETCH_ALL = 'LIST_FETCH_ALL';
const LIST_SET_ALL = 'LIST_SET_ALL';

const LIST_INVALIDATE_ALL = 'LIST_INVALIDATE_ALL';
const LIST_INVALIDATE = 'LIST_INVALIDATE';

const LIST_SUMMARY_INIT_COMPUTATIONS = 'LIST_SUMMARY_INIT_COMPUTATIONS';
const LIST_SUMMARY_SET = 'LIST_SUMMARY_SET';

const LIST_INSIGHTS_INIT_COMPUTATIONS = 'LIST_INSIGHTS_INIT_COMPUTATIONS';
const LIST_INSIGHT_SET = 'LIST_INSIGHT_SET';

const _set = lists => ({type: LIST_SET_ALL, lists});
const _update = list => ({type: LIST_UPDATE, list});
const _remove = listID => ({type: LIST_REMOVE, listID});

export const initLists = () => ({type: LIST_FETCH_ALL});
export const saveList = list => ({type: LIST_SAVE, list});
export const deleteList = listID => ({type: LIST_DELETE, listID});

export const invalidateAllLists = () => ({type: LIST_INVALIDATE_ALL});
export const invalidateList = (listID) => ({type: LIST_INVALIDATE, listID});

/*
export const initListSummariesComputation = () => ({type: LIST_SUMMARY_INIT_COMPUTATIONS});
export const initListInsightsComputation = listID => ({
  type: LIST_INSIGHTS_INIT_COMPUTATIONS,
  listID
});

const handleAsyncDataComputation = async (endpoint, commit, action) => {
  const {data: taskID} = await axios.get(fullURL(endpoint, {userID: user.ID}));

  registerListener(taskID, (event, meta) => {
    if (event === 'success' || event === 'failure') {
      unregisterListener(taskID);
    }

    if (event === 'progress') {
      const {listID, dataKey} = meta;
      axios.get(fullURL(`/computed/${dataKey}`))
        .then(({data}) => {
          commit({type: action, listID, data: {...data, dataKey}});
        })
        .catch(console.log);
    }
  });
};
*/

export default {
  state: {
    db: [],
    values: {}
  },

  getters: {
    getList: ({db}) => listID => {
      return db.find(({id}) => listID === id);
    }
  },

  mutations: {
    [LIST_SET_ALL](state, {lists}) {
      state.db = lists;
    },

    [LIST_UPDATE](state, {list}) {
      const index = state.db.findIndex(({id}) => id === list.id);
      if (index < 0) state.db.push(list);
      else state.db.splice(index, 1, {...state.db[index], ...list});
    },

    [LIST_REMOVE](state, {listID}) {
      state.db = state.db.filter(({id}) => id !== listID);
    },

    [LIST_INSIGHT_SET](state, {listID, data: {insightKey, values}}) {
      const insights = state.insights[listID] || {};
      state.insights = {
        ...state.insights,
        [listID]: {...insights, [insightKey]: values}
      };
    },

    [LIST_INVALIDATE_ALL](state) {
      state.values = {};
    },

    [LIST_INVALIDATE](state, {listID}) {
      const remove = data => {
        data = {...data};
        delete data[listID];
        return data
      };

      state.values = remove(state.values);
    }
  },


  actions: {
    async [LIST_FETCH_ALL]({commit}) {
      const {data} = await axios.get(fullURL('/list/all'));
      commit(_set(data));
    },

    async [LIST_DELETE]({commit, dispatch}, {listID}) {
      await axios.delete(fullURL(`/list/${listID}`));
      commit(_remove(listID));
    },

    async [LIST_SAVE]({commit}, {list}) {
      const {data} = await axios.post(fullURL('/list'), list);
      commit(_update(data));
    },
/*
    async [LIST_SUMMARY_INIT_COMPUTATIONS]({commit}) {
      await handleAsyncDataComputation('/list/summaries', commit, LIST_SUMMARY_SET);
    },

    async [LIST_INSIGHTS_INIT_COMPUTATIONS]({commit}, {listID}) {
      const endpoint = `/list/insights/${listID}`;
      await handleAsyncDataComputation(endpoint, commit, LIST_INSIGHT_SET);
    },*/
  }
}
